import React, { useEffect, useRef, useState } from 'react'
import errorName, { base_loading_time, url } from '../../base/Variables'
import { Stars, Rupee } from '../index'
import { useLocation, useNavigate } from 'react-router-dom'
import { LazyAxios, LazyImage, catchError, ErrorUp, getPathName, getToken, InfoPopUp, LikeIcon, setDefaultAll, Sloading, slugify, StartLoading, SuccessUp,  getDiscount, ShareIcon, productSharingMessage, InquiryIcon, MenuIcon, LazyShareButtons, } from '../../base'
import { useDispatch, useSelector } from 'react-redux'
import { changeCartTotalItem } from '../../redux/AppSlice'
import { updateCartItemList } from '../../redux/CartSlice'

const ProductCard = React.memo(({ setPerror = null, product, wishlistpage = false, changeWishlist, added = false }) => {
    // product state
    const [fav, setFav] = useState(false)
    const [deleted, setDeleted] = useState(false)
    const [outOfStock, setOutOfStock] = useState(false)

    const [success, setSuccess] = useState(null)
    const [error, setError] = useState(null)
    const [popUpMessage, setPopUpMessage] = useState(null)
    const [adding, setAdding] = useState(false)
    const [loading, setLoading] = useState(false)

    const user = useSelector((state) => state.appSlice.user)

    const [showSharingOptions, setShowSharingOptions] = useState(false)
    const shareingOptionsRef = useRef(null)
    const shareIconRef = useRef(null)

    const [showInquiryOptions, setShowInquiryOptions] = useState(false)
    const inquiryIconRef = useRef(null)
    const inquiryOptionRef = useRef(null)

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()

    async function actionOnWishList(action) {
        setLoading(true)
        try {
            const token = getToken()
            const axios = await LazyAxios()
            const request = await axios.put(`${url}/api/v1/user/wishlist/?product_id=${product.id}&action=${action}`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            if (request.data && request.data.success_message) {
                action === 'remove' ? setFav(false) : setFav(true)
                wishlistpage && changeWishlist && changeWishlist(product.id)
                setSuccess(request.data.success_message)
            }
            else if (request.data && request.data.product === null) {
                setDeleted(true)
            }
            else if (request.data && request.data.error_message) {
                setPopUpMessage(request.data.error_message)
            }
        }
        catch (error) {
            const error_message = catchError(error).error_message

            if (wishlistpage) {
                setPerror(error_message)
            }
            else {
                if (error_message === errorName.authenticationError || error_message === errorName.notNormalUser || error_message === errorName.userNotFound) {
                    setDefaultAll(dispatch, true)
                    setPopUpMessage(error_message)
                }
                else {
                    setPerror ? setPerror(error_message) : setPopUpMessage(error_message)
                }
            }
        }
        finally {
            const timeout = setTimeout(() => {
                setLoading(false)
                setAdding(false)
            }, [base_loading_time])
            return () => clearTimeout(timeout)
        }

    }

    async function addToCart() {
        try {
            setAdding(true)
            setLoading(true)
            const token = getToken()
            const axios = await LazyAxios()
            const request = await axios.post(`${url}/api/v1/cart/`, {
                'product_id': product.id,
                'shop_id': product.shop
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            if (request.data && request.data.success_message) {
                setSuccess(request.data.success_message)
                dispatch(updateCartItemList(product.id))
                request.data.success_message.includes('added') && dispatch(changeCartTotalItem({ 'type': 'inc' }))
            }
            else if (request.data && request.data.product === null) {
                setDeleted(true)
            }
            else if (request.data && request.data.out_of_stock) {
                setOutOfStock(true)
            }
            else if (request.data && request.data.error_message) {
                setPopUpMessage(request.data.error_message)
            }
        }
        catch (error) {
            const error_message = catchError(error).error_message
            if (wishlistpage) {
                setPerror(error_message)
            }
            else {
                if (error_message === errorName.authenticationError || error_message === errorName.notNormalUser || error_message === errorName.userNotFound) {
                    setDefaultAll(dispatch, true)
                    setPopUpMessage(error_message)
                }
                else {
                    setPerror ? setPerror(error_message) : setPopUpMessage(error_message)
                }
            }
        }
        finally {
            const timeout = setTimeout(() => {
                setLoading(false)
                setAdding(false)
            }, [base_loading_time])
            return () => clearTimeout(timeout)
        }
    }

    async function addToInquiryCart() {
        setShowInquiryOptions(false)
        try {
            setLoading(true)
            const token = getToken()
            const axios = await LazyAxios()
            const request = await axios.post(`${url}/api/v1/wholesale/inquiryCart/`, {
                'product_id': product.id,
                'shop_id': product.shop
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            if (request.data && request.data.success_message) {
                setSuccess(request.data.success_message)
            }
            else if (request.data && request.data.product === null) {
                setDeleted(true)
            }
            else if (request.data && request.data.error_message) {
                setPopUpMessage(request.data.error_message)
            }
        }
        catch (error) {
            const error_message = catchError(error).error_message
            if (wishlistpage) {
                setPerror(error_message)
            }
            else {
                if (error_message === errorName.authenticationError || error_message === errorName.notNormalUser || error_message === errorName.userNotFound) {
                    setDefaultAll(dispatch, true)
                    setPopUpMessage(error_message)
                }
                else {
                    setPerror ? setPerror(error_message) : setPopUpMessage(error_message)
                }
            }
        }
        finally {
            const timeout = setTimeout(() => {
                setLoading(false)
            }, [base_loading_time])
            return () => clearTimeout(timeout)
        }
    }


    function openOption(name) {
        if (name === 'share') {
            setShowSharingOptions(!showSharingOptions)
            setShowInquiryOptions(false)
        }
        else if (name === 'inquiry') {
            setShowInquiryOptions(!showInquiryOptions)
            setShowSharingOptions(false)
        }
    }

    useEffect(() => {
        if (product) {
            // normal product card initialization
            product.stock_quantity <= 0 ? setOutOfStock(true) : setOutOfStock(false)
            setDeleted(false)
            // wishlist page initialization
            wishlistpage && setFav(true)
        }
    }, [wishlistpage, product])

    useEffect(() => {

        const handleClickOutside = (event) => {
            if (shareingOptionsRef.current && !shareingOptionsRef.current.contains(event.target) && shareIconRef.current && !shareIconRef.current.contains(event.target) && inquiryOptionRef.current && !inquiryOptionRef.current.contains(event.target) && inquiryIconRef.current && !inquiryIconRef.current.contains(event.target)) {
                setShowSharingOptions(false)
                setShowInquiryOptions(false)
            }
        }

        document.addEventListener('click', handleClickOutside)

        return () => {
            document.removeEventListener('click', handleClickOutside)
        }
    }, [shareingOptionsRef, inquiryOptionRef])


    return (
        <>
            <div className={`productCard ${deleted ? 'deleted' : outOfStock ? 'outOfStock' : ''}`} id={`p${product.id}`} >
                <div className='imgdiv' onClick={() => navigate(`/product/${slugify(product.name, product.id)}/details/`)}>
                    <LazyImage src={`${url}${product.image_1}`} alt={product.name} />
                </div>
                <div className='detail'>
                    <h6 className='h7 truncate-2 name mt-1' style={{ cursor: 'pointer' }} onClick={() => navigate(`/product/${slugify(product.name, product.id)}/details/`)}>{product.name}</h6>
                    <h6 className='h6 heading d-flex gap-2' style={{ alignItems: 'center' }}><Rupee amount={product.price} /><span> ( {getDiscount(product.mrp, product.price)}% off )</span></h6>
                    <h6 className='h7 d-flex gap-2' style={{ alignItems: 'center' }}>MRP : <del className='h7 me-2'><Rupee amount={product.mrp} /></del><Stars rating={product.avg_rating} reviews={product.total_review} /></h6>
                    <div className='w-100 d-flex'>
                        {
                            user ? <div className='d-flex w-100' >
                                {
                                    outOfStock ? <button className='secondryButton h7 pt-1 pb-1  mt-0 mb-0 w-100' disabled={true}>Available Soon</button>
                                        : added ? <><button className='secondryButton h7 pt-1 pb-1  mt-0 mb-0 w-100' disabled={true}>Added In Cart</button></> : <button onClick={() => addToCart()} className='secondryButton h7 pt-1 pb-1  mt-0 mb-0 w-100' disabled={adding ? true : false}>{adding ? <Sloading /> : 'Add To Cart'}</button>

                                }
                                <button style={{ position: 'absolute', bottom: '82px', right: '7px' }} className='iconSpan' onClick={() => actionOnWishList(fav ? 'remove' : 'add')} disabled={loading ? true : false}><LikeIcon style={{width : '26px'}} className={fav && 'fav'} /></button>
                            </div> :
                                <button className='secondryButton h7 pt-1 pb-1  mt-0 mb-0 w-100' onClick={() => navigate(`/user/loginUser/?redirect=${getPathName(location)}`)}>Please Login</button>
                        }
                    </div>
                </div>

                <div className={deleted || outOfStock ? `d-flex deletedMsg outOfStockMsg h5` : 'd-none h5'}>{deleted ? 'Product Deleted' : 'Out Of Stock'}</div>

                {/* options */}

                <span ref={shareIconRef} className='shareIconSpan' onClick={() => openOption('share')}><ShareIcon /></span>
                <div ref={shareingOptionsRef} className={`sharingOptions ${showSharingOptions ? 'show' : ''}`}>
                    <h6 className='h7' style={{ textDecoration: 'underline' }}>Share this product</h6>

                    <LazyShareButtons className='d-flex gap-3 align-items-center flex-wrap' url={`${url}/product/${slugify(product.name, product.id)}/details/`} quote={productSharingMessage} />

                </div>

                {/* {
                    user && <> */}
                        <span ref={inquiryIconRef} className={`inquiryIconSpan ${user ? 'd-flex' : 'd-none'}`} onClick={() => openOption('inquiry')}><InquiryIcon /></span>
                        <div ref={inquiryOptionRef} className={`sharingOptions gap-0 ${showInquiryOptions ? 'show' : ''}`}>
                            <div className='h7 text-center mb-2'>To buy product in bulk/wholesale, follow this</div>
                            <ul style={{ paddingLeft: '1rem' }}>
                                <li className='smallText'>Add this product to inquiry cart.</li>
                                <li className='smallText'><div>Click Menu Icon <MenuIcon className='pcolor ms-1 me-1' style={{ width: '17px' }} /> at top-left of page and go to inquiry cart.</div></li>
                                <li className='smallText'>Submit your inquiry and wait for dealer response</li>
                            </ul>
                            <button className='secondryButton h7 m-0' onClick={() => addToInquiryCart()}>Add</button>
                        </div>
                    {/* </>
                } */}


            </div>
            <hr />
            {
                loading ? <StartLoading /> :
                    popUpMessage ? <InfoPopUp popUpMessage={popUpMessage} setPopUpMessage={setPopUpMessage} /> :
                        error ? <ErrorUp message={error} removeMessage={setError} /> : success ? <SuccessUp message={success} removeMessage={setSuccess} /> : <></>

            }

        </>
    )
})

export default ProductCard